import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=4e1cef1e&scoped=true&"
import script from "./DashboardLayout.vue?vue&type=script&lang=js&"
export * from "./DashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1cef1e",
  null
  
)

export default component.exports